import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import Menu from "../components/Menu/Menu";

function Quiz() {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState(() => {
    const saved = sessionStorage.getItem('answers')
    return saved ? JSON.parse(saved) : {}
  });
  const [questionsValidated, setQuestionsValidated] = useState(0);

  // On charge les questions depuis le fichier JSON
  useEffect(() => {
    fetch("./data/quiz.json")
      .then((response) => response.json())
      .then((data) => setQuestions(data))
      .catch((error) => console.error("Erreur lors du chargement :", error));
  }, []);

  // On enregistre dans le sessionStorage à chaque mise à jour des réponses
  useEffect(() => {
    sessionStorage.setItem('answers', JSON.stringify(answers))
  }, [answers])

  // Gestion du cas de figure si l'url est de la forme /quiz/
  const navigate = useNavigate();
  const location = useLocation();
  if(location.pathname === "/quiz/") {
    navigate("/quiz/0");
  }

  // On récupère le paramètre dans l'URL si il existe et on le convertit en entier
  const { qid } = useParams();
  const questionIndex = parseInt(qid, 10);

  // Classes du container en fonction des contextes
  let containerClasses = "page";
  if(location.pathname === "/quiz/result") {
    containerClasses += " page--result";
  } else {
    containerClasses += " page--quiz";
  }

  return (
    <div className={containerClasses}>
      {questions.length > 0 &&
        <>
          <Menu questions={questions} answers={answers} questionIndex={questionIndex} questionsValidated={questionsValidated} />
          <Outlet context={{questions, answers, setAnswers, questionsValidated, setQuestionsValidated, questionIndex}} />
        </>
      }
    </div>
  )
}

export default Quiz;
